import * as ApiWithToken from "../callApiWithToken";

const activitiesService = {
    getActivitiesByAppointment:async function(appointmentId:number, languageId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `Activities?appointmentID=${appointmentId}&languageID=${languageId}&isWeb=true`);
    },
    getActivitiesByAppointmentCheckIn:async function(appointmentId:number, languageId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `AngendaManagement/GetActivitiesCheckIn?appointmentID=${appointmentId}&languageID=${languageId}&isWeb=true`);
    }
}
export default activitiesService;
